import { WebApiActionGet, WebApiActionPost, QueryParams, WebApiItems } from "components/ajax/WebApi";
import { Hostovani } from "../Clenove/HostovaniDlouhodoba";

import rootUrl from "./url";

const baseUrl = rootUrl + "hostovani-dlouhodoba/";


export const PotvrzeniHostovani = function (hostovaniId: number): WebApiActionPost<{}, Hostovani> {
    return new WebApiActionPost<{}, Hostovani>(baseUrl + `potvrzeni/${hostovaniId}`);
}

export const ZamitnutiHostovani = function (hostovaniId: number): WebApiActionPost<{}, Hostovani> {
    return new WebApiActionPost<{}, Hostovani>(baseUrl + `zamitnuti/${hostovaniId}`);
}